import { useCallback, useReducer } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'

export const ActionType = {
  SATRT_LOADING: 'SATRT_LOADING',
  SET_NOTES: 'SET_NOTES',
  FETCH_ERROR: 'FETCH_ERROR',
  OPEN_VEIW_NOTE: 'OPEN_VEIW_NOTE',
  CLOSE_VEIW_NOTE: 'CLOSE_VEIW_NOTE',
  OPEN_FORM_DIALOG: 'OPEN_FORM_DIALOG',
  CLOSE_FORM_DIALOG: 'CLOSE_FORM_DIALOG',
  CREATE_SUCCESS: 'CREATE_SUCCESS',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  UPDATE_SUCCESS: 'UPDATE_SUCCESS',
}

const initialState = {
  notes: [],
  isLoading: false,
  noteDetail: undefined,
  openView: false,
  openDelete: false,
  openFormDialog: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SATRT_LOADING:
      return {
        ...state,
        isLoading: true,
      }
    case ActionType.SET_NOTES:
      return {
        ...state,
        isLoading: false,
        notes: action.payload,
      }
    case ActionType.FETCH_ERROR:
      return {
        ...state,
        isLoading: false,
      }
    case ActionType.OPEN_VEIW_NOTE:
      return {
        ...state,
        openView: true,
        noteDetail: action.payload,
      }
    case ActionType.OPEN_FORM_DIALOG:
      return {
        ...state,
        openFormDialog: true,
        noteDetail: action.payload,
      }

    case ActionType.CREATE_SUCCESS:
    case ActionType.UPDATE_SUCCESS:
      return {
        ...state,
        openFormDialog: false,
        isLoading: true,
      }

    case ActionType.DELETE_SUCCESS:
      return {
        ...state,
        openFormDialog: false,
        isLoading: false,
        notes: action.payload,
      }

    case ActionType.CLOSE_VEIW_NOTE:
    case ActionType.CLOSE_FORM_DIALOG:
      return {
        ...initialState,
        notes: state.notes,
        noteDetail: undefined,
      }

    default:
      return state
  }
}

export default function useNotes() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { formatMessage } = useIntl()
  const commonDispatch = useDispatch()

  const handleAlertError = useCallback(() => {
    dispatch({ id: ActionType.FETCH_ERROR })
    return commonDispatch(
      MessageAlert.showError({
        message: formatMessage({
          id: 'error.general',
        }),
      }),
    )
  }, [commonDispatch, formatMessage])

  const fetchNotes = ({ subscriberId }) => {
    effects.apis
      .getNotesBySubscriberId({
        'filter[subscriberId]': subscriberId,
        isPagination: 0,
      })
      .then((response) => {
        dispatch({ type: 'SET_NOTES', payload: response.data })
      })
      .catch(() => handleAlertError())
  }

  const handleFetchNotes = ({ subscriberId }) => {
    dispatch({ type: 'SATRT_LOADING' })
    fetchNotes({ subscriberId })
  }

  const onUpdateNotes = ({ subscriberId, noteId, text }) => {
    effects.apis
      .updateNotes({ noteId, text })
      .then((res) => {
        commonDispatch(
          MessageAlert.showSuccess({
            message: formatMessage({ id: 'note.successSaved' }),
          }),
        )
        dispatch({ type: ActionType.UPDATE_SUCCESS })
        setTimeout(() => {
          fetchNotes({ subscriberId })
        }, 500)
      })
      .catch(() => handleAlertError())
  }

  const onCreateNote = ({ subscriberId, text }) => {
    effects.apis
      .createNotes({ subscriberId, text })
      .then((res) => {
        commonDispatch(
          MessageAlert.showSuccess({
            message: formatMessage({ id: 'note.successSaved' }),
          }),
        )
        dispatch({ type: ActionType.CREATE_SUCCESS })
        setTimeout(() => {
          fetchNotes({ subscriberId })
        }, 500)
      })
      .catch(() => handleAlertError())
  }

  const onDeleteNote = ({ subscriberId, noteId }) => {
    dispatch({ type: ActionType.SATRT_LOADING })
    effects.apis
      .deleteNoteById({ noteId })
      .then((res) => {
        commonDispatch(
          MessageAlert.showSuccess({
            message: formatMessage({ id: 'note.successDeleted' }),
          }),
        )
        const newData = state.notes.filter((item) => item.id !== noteId)

        dispatch({ type: ActionType.DELETE_SUCCESS, payload: newData })
      })
      .catch(() => handleAlertError())
  }

  const onOpenViewNote = (note) => {
    dispatch({ type: ActionType.OPEN_VEIW_NOTE, payload: note })
  }
  const closeViewNote = () => {
    dispatch({ type: ActionType.CLOSE_VEIW_NOTE })
  }
  const onOpenFormDialog = (note = undefined) => {
    dispatch({ type: ActionType.OPEN_FORM_DIALOG, payload: note })
  }
  const onCloseFormDialog = () => {
    dispatch({ type: ActionType.CLOSE_FORM_DIALOG })
  }

  return {
    state,
    handleFetchNotes,
    onUpdateNotes,
    onDeleteNote,
    onCreateNote,
    onOpenViewNote,
    closeViewNote,
    onOpenFormDialog,
    onCloseFormDialog,
  }
}
